<template>
  <router-view />
</template>

<script>
export default {
  name: "TrainingIndex",
};
</script>